import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagRecordCategoryEnum } from '../enums/tag-record-category.enum';

/**
 * Tag DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.TAG)
export class TagSearchDto extends BaseSearchDto {
  name!: string;
  recordCategory!: TagRecordCategoryEnum;
  files?: FileDto[] | null;
}
